'use client'
import Script from 'next/script'
import { iab } from './iab'
import { useEffect, useState } from 'react'
import { isPurMode } from '@/utils/app/paid'
import { consentMustRejected, rejectConsent } from '@/libs/consent/consent'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'
import { getAppConfig } from '@/config/config'

type SourcepointProps = {
  cookies: RequestCookie[]
}

const config = getAppConfig()

export const Sourcepoint = ({ cookies }: SourcepointProps) => {
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (navigator.cookieEnabled) {
      if (globalThis.window.__tcfapi) {
        // reject consent for pur user
        if (consentMustRejected(cookies)) {
          rejectConsent()
        }
      }

      globalThis.window._sp_ = {
        config: {
          accountId: config.consent.sourcepoint.accountId,
          baseEndpoint: config.consent.sourcepoint.baseEndpoint,
          targetingParams: {
            hasPurAbo: isPurMode(cookies),
          },
          gdpr: {},
          events: {
            onPrivacyManagerAction: function () {
              setTimeout(function () {
                globalThis.window.location.reload()
              }, 300)
            },
          },
        },
      }
    }
    setInitialized(true)
  }, [])

  return (
    initialized && (
      <>
        <Script id="iab-script" dangerouslySetInnerHTML={{ __html: iab }} />
        <Script
          src="https://sourcepoint.n-tv.de/unified/wrapperMessagingWithoutDetection.js"
          onError={() => globalThis.window.dispatchEvent(new Event('sp_error'))}
        />
      </>
    )
  )
}
